import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import EfProgress from '@elem/ui/ef-progress';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionE');
    const refDom = useRef(null);
    const [isEnter, setIsEnter] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            (elems: any) => {
                const elem = elems[0];
                const topNum = elem.boundingClientRect.top;

                if (elem.isIntersecting && topNum > 0) {
                    setIsEnter(true);
                }
            },
            {
                rootMargin: `0px 0px 0px 0px`,
                threshold: 0.5,
            },
        );
        observer.observe(refDom.current as any);
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <div className="SectionE-label-icon">
                <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722326378837/X-core.png" />
            </div>
            <EfSection hasAnimation={false} title={t('title')} desc={t('desc')} />
            <div className="ef-container SectionE-in" ref={refDom}>
                <div className="SectionE-l">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1722859195656/c1.jpg" />
                </div>
                <div className="SectionE-r">
                    <div className="SectionE-text1">{t('con1')}</div>
                    <div className="SectionE-item SectionE-item-1">
                        <EfProgress isEnter={isEnter}>{t('a_text2')}</EfProgress>
                        <div className="SectionE-line2">{t('a_text1')}</div>
                    </div>
                    <div className="SectionE-item SectionE-item-2">
                        <EfProgress isEnter={isEnter} theme="blue">
                            {t('b_text2')}
                        </EfProgress>
                        <div className="SectionE-line2">{t('b_text1')}</div>
                    </div>
                    <div className="SectionE-item SectionE-item-3">
                        <EfProgress isEnter={isEnter} theme="blue">
                            {t('c_text2')}
                        </EfProgress>
                        <div className="SectionE-line2">{t('c_text1')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
